import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import type { IRenderContextMenuItemArgs } from '@/plugins/context-menu/type';
import { LayerHotkeyType } from '../../type';

export const layerLockItem = ({ activeLayer, pickLayer }: IRenderContextMenuItemArgs, identity: string) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);
    const layer = pickLayer || activeLayer;

    if (!layer) return null;

    const type = LayerHotkeyType.LOCK;
    const item = {
        name: $t((v) => v.contextMenuLayer.menu[layer.lock ? 'unLock' : 'lock']),
        type,
        desc: framework.service.hotkey.getDesc(type),
        onClick: () => {
            framework.service.hotkey.__emit(type, { from: 'context-menu' });
        },
    };

    return item;
};
